export { default as commonLable } from "./commonLable";
export { default as commonTitle } from "./commonTitle";
export { default as commonDialog } from "./commonDialog";
export { default as itemTitle } from "./itemTitle";